import { useEffect } from "react";
import SiouxCityHeroSection from "./components/HeroSection";
import SiouxCityStickyNav from "./components/StickyNav";
import SiouxCityProcessingTimeSection from "./components/ProcessingTimeSection";
import SiouxCityServicesSection from "./components/ServicesSection";
import SiouxCityLocalAreaSection from "./components/LocalAreaSection";
import SiouxCityTestimonialsSection from "./components/TestimonialsSection";
import SiouxCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SiouxCityComparisonSection from "./components/ComparisonSection";
import SiouxCityMistakesSection from "./components/MistakesSection";
import SiouxCityHowItWorksSection from "./components/HowItWorksSection";
import SiouxCityFAQSection, { faqs } from "./components/FAQSection";
import SiouxCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SiouxCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function SiouxCityPage() {
  useEffect(() => {
    document.title = "Emergency Passport Sioux City IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/sioux-city/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Sioux City, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Woodbury County, the Tri-State area, Western Iowa families, National Guard members, and business travelers.");
    setMeta("geo.placename", "Sioux City, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "42.4999;-96.4003");
    setMeta("ICBM", "42.4999, -96.4003");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "Sioux City Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Sioux City and Western Iowa residents. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Sioux City", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <SiouxCityHeroSection />
      <SiouxCityStickyNav />
      <SiouxCityProcessingTimeSection />
      <SiouxCityServicesSection />
      <SiouxCityLocalAreaSection />
      <SiouxCityTestimonialsSection />
      <SiouxCityAcceptanceFacilitiesSection />
      <SiouxCityComparisonSection />
      <SiouxCityMistakesSection />
      <SiouxCityHowItWorksSection />
      <SiouxCityFAQSection />
      <SiouxCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/sioux-city" state="IA" />
      <SiouxCityFinalCTA />
    </div>
  );
}